import { type FC } from 'react';
import '@Styles/spinner.css';

interface SpinnerProps {
  showSpinner: boolean;
}

const Spinner: FC<SpinnerProps> = ({ showSpinner }) => {
  if (!showSpinner) return null;
  return (
    <div className="spinner__overlay">
      <div className="spinner__circle" />
    </div>
  );
};

export default Spinner;
